export interface Camera {
  name: string
  object: any
}

export const NO_CAMERA: Camera = {
  name: 'No camera',
  object: { deviceId: 'NO_CAMERA' },
}
